import axios from "axios";
import { ip_back } from "../../config";

const getToken = () => localStorage.getItem("token");

const headers = () => ({
  headers: { Authorization: getToken() },
});

const base = () => `${String(ip_back || "").replace(/\/?$/, "/")}`;

export async function fetchSmartProfile(userId = null, lang = "en") {
  const path = userId
    ? `api/digiping/smart/${encodeURIComponent(userId)}`
    : "api/digiping/smart";
  const res = await axios.get(`${base()}${path}`, {
    ...headers(),
    params: { lang },
  });
  return res.data?.data || null;
}

export async function saveSmartProfile(payload) {
  const res = await axios.put(`${base()}api/digiping/smart`, payload, headers());
  return res.data?.data || null;
}

export async function savePlayerSmartProfile(userId, payload) {
  const res = await axios.put(
    `${base()}api/digiping/smart/${encodeURIComponent(userId)}`,
    payload,
    headers()
  );
  return res.data?.data || null;
}

export async function fetchSmartEvents({ as = "coach", status = "pending", playerId } = {}) {
  const res = await axios.get(`${base()}api/digiping/smart-events`, {
    ...headers(),
    params: { as, status, playerId },
  });
  return res.data?.data || [];
}

/** Coach SMART roster for players in assigned groups. */
export async function fetchGroupSmartRoster({ grId = null, lang = "en" } = {}) {
  const res = await axios.get(`${base()}api/digiping/smart/group-roster`, {
    ...headers(),
    params: {
      lang,
      ...(grId ? { gr_id: grId } : {}),
    },
  });
  return res.data?.data || { groups: [], players: [] };
}

export async function reviewSmartEvent(eventId, body) {
  const res = await axios.post(
    `${base()}api/digiping/smart-events/${encodeURIComponent(eventId)}/review`,
    body,
    headers()
  );
  return res.data?.data || null;
}

/** Assigned SMART goal exercise ids for live auto-eval (soft/hard). */
export async function fetchGoalExerciseIds() {
  const res = await axios.get(`${base()}api/digiping/smart/goal-exercise-ids`, headers());
  return res.data?.data || [];
}

export async function createSmartEvent(body) {
  const res = await axios.post(`${base()}api/digiping/smart-events`, body, headers());
  return res.data?.data || null;
}

/** Player / coach: request R revision (coach must validate to close SMART loop). */
export async function requestSmartRevision(body) {
  const res = await axios.post(
    `${base()}api/digiping/smart/revision-request`,
    body,
    headers()
  );
  return res.data?.data || null;
}

/** Upsert A milestones (optional coach approval). */
export async function saveSmartMilestones(body) {
  const res = await axios.post(
    `${base()}api/digiping/smart/milestones`,
    body,
    headers()
  );
  return res.data?.data || null;
}

/** Coach group / team-tag SMART goals. */
export async function fetchScopeSmartGoals({
  grId = null,
  scopeTag = null,
  lang = "en",
} = {}) {
  const res = await axios.get(`${base()}api/digiping/smart/scope`, {
    ...headers(),
    params: {
      lang,
      ...(grId ? { gr_id: grId } : {}),
      ...(scopeTag ? { scope_tag: scopeTag } : {}),
    },
  });
  return res.data?.data || [];
}

export async function saveScopeSmartGoal(body) {
  const res = await axios.post(
    `${base()}api/digiping/smart/scope`,
    body,
    headers()
  );
  return res.data?.data || null;
}

export async function deactivateScopeSmartGoal(id) {
  const res = await axios.post(
    `${base()}api/digiping/smart/scope/${encodeURIComponent(id)}/deactivate`,
    {},
    headers()
  );
  return res.data?.data || null;
}

export async function fetchTeamTags({ grId, week = null } = {}) {
  const res = await axios.get(`${base()}api/digiping/smart/team-tags`, {
    ...headers(),
    params: {
      gr_id: grId,
      ...(week ? { week } : {}),
    },
  });
  return res.data?.data || null;
}

export async function recomputeTeamTags({
  grId,
  weekStart = null,
  resetManual = false,
} = {}) {
  const res = await axios.post(
    `${base()}api/digiping/smart/team-tags/recompute`,
    {
      gr_id: grId,
      week_start: weekStart,
      reset_manual: resetManual,
    },
    headers()
  );
  return res.data?.data || null;
}

/** Store a coach voice transcript on the player's next training cycle. */
export async function saveCycleFeedbackCue({ playerId, text, teId } = {}) {
  if (!playerId || !text) return null;
  const res = await axios.post(
    `${base()}api/digiping/smart/${encodeURIComponent(playerId)}/cycle-feedback`,
    { text, teId: teId || null, playerId },
    headers()
  );
  return res.data?.data || null;
}

/** Full SMART trail for the player profile tab. */
export async function fetchSmartTrail(userId = null, lang = "en") {
  const path = userId
    ? `api/digiping/smart/trail/${encodeURIComponent(userId)}`
    : "api/digiping/smart/trail";
  const res = await axios.get(`${base()}${path}`, {
    ...headers(),
    params: { lang },
  });
  return res.data?.data || null;
}
